(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
 const button=event.target.closest('.reluma-buy-now');
 if(!button||button.disabled)return;
 const source=button.closest('form');
 const variant=source.querySelector('[name="id"]');
 if(!variant||variant.disabled||!source.reportValidity())return;
 const checkout=document.createElement('form');
 checkout.method='post';checkout.action=source.action;checkout.hidden=true;
 const data=new FormData(source);
 data.set('return_to',button.dataset.checkoutUrl);
 if(!data.has('quantity'))data.set('quantity','1');
 for(const [name,value] of data){if(typeof value!=='string')continue;const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;checkout.appendChild(input);}
 document.body.appendChild(checkout);checkout.submit();
});
  } catch(e) { console.error(e); }
})();

})();
